// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "87b5cf9ef3e9c368b198766a0dee23dcf3189374/static/css/" + chunkId + "." + {"200":"4f7b3521","825":"f81e5cfb","864":"f2764e67"}[chunkId] + ".chunk.css";
};